export const routes = {
  home: '/',
  auth: {
    login: '/login',
    register: '/register',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
  },
  legal: {
    privacyPolicy: '/privacy-policy',
    termsAndConditions: '/terms-and-conditions',
    returnsAndRefunds: '/returns-and-refunds',
    shipping: '/shipping',
  },
  dashboard: {
    index: '/dashboard',
    account: '/dashboard/account',
    myCarts: {
      index: '/dashboard/my-carts',
      create: '/dashboard/my-carts/create',
      cart: {
        items: '/dashboard/my-carts/$cartId/items',
        checkout: '/dashboard/my-carts/$cartId/checkout',
        checkoutSuccess: '/dashboard/my-carts/$cartId/checkout-success',
        checkoutFail: '/dashboard/my-carts/$cartId/checkout-fail',
      },
    },
    orders: '/dashboard/orders',
    practitioners: '/dashboard/practitioners',
    myOrders: {
      index: '/dashboard/my-orders',
    },
    users: '/dashboard/users',
    subscriptionOrder: '/dashboard/subscription/$orderId', // Added this line based on the instruction's intent
    subscription: {
      index: '/dashboard/subscription',
      cart: {
        items: '/dashboard/subscription/$cartId/items',
        checkout: '/dashboard/subscription/$cartId/checkout',
        checkoutSuccess: '/dashboard/subscription/$cartId/checkout-success',
        checkoutFail: '/dashboard/subscription/$cartId/checkout-fail',
      },
    },
    supplements: '/dashboard/supplements',
    statistics: '/dashboard/statistics',
    qrCodes: '/dashboard/qr-codes',
  },
  invitation: '/invitation/$invitationId',
  help: {
    index: '/help',
    gettingStarted: '/help/getting-started',
    shipping: '/help/shipping',
    safetyPrivacy: '/help/safety-privacy',
    supplementsRefills: '/help/supplements-refills',
    contactUs: '/help/contact-us',
  },
  ingredients: {
    index: '/ingredients',
    ingredient: '/ingredients/$ingredientId',
  },
  protocols: '/protocols',
} as const;
